import {parseCitiesData} from "./data/parse-cities-data";
import {renderCities} from "./render-alphabet-cities";
import {renderContactContent} from "./render-contact-content";
import {getPage} from "./require/get-page";

const contactB2CElement = document.querySelector(`.franchise-page__B2CContent--right`);


export const initPlaceholderPage = () => {
  const isOnlyOneShop = Object.keys(shopListData).length === 1;

  const contentElement = document.querySelector(`.franchise-page__content`);
  contentElement.dataset.mode = `b2c`;

  const B2CElement = document.querySelector(`.franchise-page__B2CWrap`);
  B2CElement.dataset.mode = isOnlyOneShop ? `one` : `more`;


  const cityB2CElement = document.querySelector(`.franchise-page__B2CContent--left`);
  if (!isOnlyOneShop) {
    const cities = parseCitiesData(shopListData, shopInfoData);
    renderCities(contactB2CElement, cityB2CElement.querySelector(`.cities__list`), cities);
  }

  if (shopInfoData.shop_id) {
    getPage(shopInfoData.shop_id, (data) => {
      renderContactContent(contactB2CElement.querySelector(`div`), data);
    });
  }
};
